import { type ReactNode } from 'react';
import styles from './Card.module.css';

interface CardProps {
  title: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

export function Card({ title, actions, children }: CardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.head}>
        <div className={styles.title}>{title}</div>
        {actions && <div>{actions}</div>}
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
}
